import React, { ReactComponentElement } from 'react'

import { ROUTE_URLS } from 'router/routes'

import { localeCommonKeysType } from 'shared/locale/en-US'

import { ReactComponent as live1 } from '../img/live1.svg'
import { ReactComponent as live2 } from '../img/live2.svg'
import { ReactComponent as sport1 } from '../img/sport1.svg'
import { ReactComponent as sport2 } from '../img/sport2.svg'
import { ChoiceOfSport } from '../types'
interface IChoiceOfSportTypes {
  link: string
  mobileLink?: string
  text: localeCommonKeysType
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
}
export const choiceofSport: Record<ChoiceOfSport, IChoiceOfSportTypes[]> = {
  sport: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
      text: 'sportBetting1',
    },
    {
      link: ROUTE_URLS.BETBY_SPORT(),
      text: 'sportBetting2',
    },
    {
      link: ROUTE_URLS.SOFTION_SPORT(),
      text: 'sportBetting3',
    },
  ],
  liveSport: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
      text: 'liveBetting1',
    },
    {
      link: ROUTE_URLS.BETBY_SPORT('live'),
      text: 'liveBetting2',
    },
    {
      link: ROUTE_URLS.SOFTION_SPORT_LIVE(),
      text: 'liveBetting3',
    },
  ],
  betHistory: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'),
      text: 'betHistory1',
    },
    {
      link: ROUTE_URLS.BETBY_SPORT('bets'),
      text: 'betHistory2',
    },
  ],
}
